// eslint-disable-next-line import/no-anonymous-default-export
export default {
  dashboard: "Dashboard",
  templates: "Templates",
  workflow: "Workflow",
  content: "Content",
  company: "Company",
  Communication: "Communication",
  Staff: "Staff",
  created_at: "Created Date",
  Checklist: "Checklist",
  Settings: "Settings",
  activity_log: "Activity Log",
  name: "Name",
  staff_mang: "Staff management",
  Edit_btn: "Edit Button",
  create_staff: "Create Staff",
  update_staff: " Edit Staff",
  delete: "Delete",
  edit: "Edit",
  create: "Create",
  update: "Update",
  cancel: "Cancel",
  role: "Role",
  plce_role: "Please enter role ",
  role_rule: "Please select role ",
  action: "Action",
  phone_no: "Phone",
  phone_rule: "Please enter a valid phone number",
  plce_phoneno: "Enter Phone ",
  email: "Email",
  plce_email: " Enter email",
  email_rule: "Please enter email",
  lastname: "Last Name",
  lname_rule: "Please enter last name ",
  plce_lastname: "Enter last name",
  plce_firstname: "Enter first name",
  fname_rule: "Please enter first name ",
  firstname: "First Name",
  Create_temp: "Create template",
  update_temp: "Update template",
  active: "Active",
  submit: "Submit",
  approvars: "Approvars",
  addnew: "Add new",
  view: "View",
  title: "Title",
  single: "Single",
  multiple: "Multiple",
  inp_type: "Input type",
  grid_type: "Grid type",
  selec_type: "Select type of view",
  placeholder: "Placeholder",
  plce_grid: "Select your grid type",
  plce_type: "Select your input type",
  plce_title: " Enter title",
  ent_plce: "Enter placeholder",
  rule_grid: "Please select grid type!",
  rule_type: "Please select template type!",
  rule_title: "Please input your title",
  options: "Options",
  Add_field: "Add field",
  options_rule: "Please input options's name",
  option_name: "Enter option name",
  val_type: "Type of value",
  ent_info: "Enter info",
  ent_label: "Enter label",
  ent_field: "Enter field name",
  info: "Info",
  required: "Required",
  add_attribute: "Add attribute",
  create_workflow: "Create workflow",
  workflow_name: "Name",
  workflow_type: "Type",
  description: "Description",
  checklist: "Checklist",
  company_rule: "Please! enter a company name ",
  select: "Select",
  plce_company: "Select a company name",
  desc_rule: "Please enter a description ",
  workflow_type_rule: "Please select workflow type",
  workflow_rule: "Select a workflow type",
  plce_workflow: "Enter a workflow name",
  plce_workflow_type: "Enter a workflow type",
  plce_checklist: "Select a checklist",
  create_work: "Go to  create workflow",
  con_Content: "Contract content",
  create_content: "Create Content",
  update_content: "Update Content",
  content_name: "Content Name",
  content_type: "Content Type",
  plce_content_type: "Enter type",
  content_type_rule: "Please enter a content type",
  content_name_rule: "Please enter a content name",
  plce_content_name: "Enter name",
  content_rule: "Please enter a content",
  plce_content: "Enter a content",
  create_company: "Create Company",
  company_name: "Company Name",
  address: "Address",
  pincode: "Zip Code",
  categoryId: "  CategoryId",
  update_company: "Update company",
  cname_rule: "Please enter a company name",
  cname_placeholder: "Enter Company Name",
  address_rule: "Please enter a company address",
  plce_address: "Enter address",
  plce_pincode: "Enter zipcode",
  pincode_rule: "Please enter a zipcode",
  workflow_Services: "Workflow Services",
  template_Services: "Template Services",
  content_Services: "Content Services",
  workflowtype_Services: "WorkflowType services",
  option_rule: "Option required",
  category_name: "Category Name",
  create_category: "Create Category",
  update_category: "Update Category",
  categoryname: "Category name",
  category_rule: "Please! enter a category name",
  rule_description: "Please enter a description",
  plce_description: "Enter a description",
  category: "Category",
  plce_category: "Enter a category",
  create_checklist: "Create checklist",
  update_checklist: "Update checklist",
  checklist_name: "Checklist name",
  contentType: "Content Type",
  contractType: "Contract Type",
  contentType_rule: "Please enter a content type.",
  contractType_rule: "Please enter a contract type.",
  plce_contentType: "Enter a content type",
  plce_contractType: "Enter a contract type",
  create_contentType: "Create Contract Type",
  update_contentType: "Update Contract Type",
  selecttemp: "Select a template",
  selectcontent: "Select a content",
  close: "Close",
  create_Approval: "Create Approval",
  add_approval: "Add Approval",
  levelname: "Level Name",
  strategy: "Strategy",
  update_workflow: "Update Workflow",
  update_password: "Update Password",
  enter_comment: "Enter Comment",
  Template: "Template",
  template: "Templates",

  levelname_rule: "Please enter  level name",
  plce_levelname: "Enter level name",
  workflow_typename: "Workflowtype Name",
  workflow_type_delete: "Are you sure you want to delete this Workflowtype?",
  yes: "Yes",
  no: "No",
  change: "Change",
  create_workflow_type: "Create Workflow Type",
  update_workflow_type: "Update Workflow Type",
  workflow_type_name: "Workflow type name",
  workflowtype_rule: "Please! enter a workflowtype name",
  plce_workflowtype: "Please enter workflow name",
  TimelineComment: "Timeline/Comment",
  please_select_template: "Please select template",
  please_select_content: "Please select content",
  please_select_checklist: "Please select checklist",
  approval: "Approval",
  profile: "Profile",
  resetpassword: "Reset Password",
  reset: "Reset",
  Userdetails: "User Details",
  updatepassword: "Update Password",
  vendor: "Vendor",
  vendors: "Vendors",
  vendor_mang: "Vendor Management",
  create_vendor: "Create Vendor",
  firstName: "First Name",
  lastName: "Last Name",
  save: "Save",
  phoneno: "Phone",
  gender: "Gender",
  update_vendor: "Update Vendor",
  agrrement_management: "Agreement Management",
  refresh: "Refresh",
  task_management: "Task Management",
  create_task: "Create Task",
  update_task: "Update Task",
  task: "Task",
  taskname: "Task Name",
  startdate: "Start Date",
  enddate: "End Date",
  taskname_rule: "Please enter a task name",
  plce_taskname: "Enter a task name",
  plce_enddate: "Select end date",
  enddate_rule: "Please select end date",
  plce_startdate: "Select start date",
  startdate_rule: "Please Select start date",
  task_details: "Task Details",
  company_delete_title: "Are you sure delete this Company?",
  content_delete_title: "Are you sure you want to delete this Content?",
  field_delete_title: "Are you sure you want to delete this field?",

  contenttype_delete_titte:
    "Are you sure delete you want to this Content type?",
  category_delete_title: "Are you sure delete this Category?",
  vendor_delete_title: "Are you sure you want to delete this Vendor?",
  task_delete_title: "Are you sure you want to delete this task?",
  approval_delete_title: "Are you sure you want to delete this Approval?",
  checklist_delete_titte: "Are you sure you want to delete this Checklist?",
  search_: "Search...",
  new_password: "New Password",
  new_password_rule: "Please Input Your New Password!",
  new_password_plce: "Enter New Password",
  confirm_password_plce: "Confirm Your Password",
  confirm_password_rule: "Please Confirm Your Password!",
  password_not_match: "The Two Passwords That You Entered Do Not Match!",
  confirm_password: "Confirm Password",
  company_details: "Company Details",
  workflow_delete_title: "Are you sure you want to delete this Workflow?",
  staff_delete_title: "Are you sure you want to delete this Staff?",
  staff_delete_title_contract: "Are you sure you want to delete this contract?",
  template_delete_title: "Are you sure you want to delete this Template?",
  WorkflowType: "WorkflowType",
  comments: "Comments",
  detailview: "Detail View",
  task_name: "Task Name",
  status: "Status",
  task_template_name: "Task template name",
  Select_vendor: "Select vendor",
  please_select_vendor: "Please Select Vendor",
  please_select_staff: "Please Select staff",
  forgot_password: "Forget password",
  data_not_found: "Data Not Found",
  new_password_rules: "Password must be of 6-16 characters",
  new_password_patternrules:
    "Your password must have uppercase and lowercase letters, at least one number,at least one special character, and be between 8 and 16 characters long. Please try again.",
  new_password_patternrules_new:
    "Your password must have uppercase and lowercase letters, at least one number,at least one special character, and be between 8 and 16 characters long. Please try again.",
  confirm_password_checkrule: "Passwords do not match, please retype",
  edit_comment: "Edit Comment",
  rule_label: "Please enter a label",
  rule_datatype: "Please select a datatype",
  company_owner_detail: "Company owner details",
  Enter_Comment_here: "Enter comment here",

  pleaseEnterComment: "Please enter comment",
  today: "Today",
  tomorrow: "Tomorrow",
  yesterday: "Yesterday",
  edit_content: "Edit Content",
  edit_template: "Edit template",
  basic_details: "Basic Details",
  fields_details: "Fields Details",
  next: "Next",
  previous: "Previous",
  Accept: "Accept",
  rule_category: "Please! select category",
  login: "Login",
  forget_your_password: "Forgot your password?",
  password: "Password",
  password_rule: "Please input your Password!",
  useremail_rule: "Please input your Useremail!",
  useremail: "Useremail",
  plce_workflow_task: "Select a workflow type",
  noDataFound: "No data found",
  wait: "Wait",
  no_record_found: "No Record Found",
  workflow_management: "workflowMangement",
  logout: "Logout",
  super_admin: "Super Admin",
  step: "Step",
  step_1: "Step 1",
  step_2: "Step 2",
  step_3: "Step 3",
  input_comment_rule: "Please enter comment",
  select_all: "Select all",
  checklist_detail: "Checklist Details",
  content_detail: "Content Details",
  template_detail: "Template Details",
  approval_detail: "Approval Details",
  changepassword: "Change password",
  plce_strategy: "Select strategy",
  please_strategy: "Please select strategy",
  level: "Level",
  reject: "Reject",
  task_managementVendor: "Task Management Vendor",
  selectchecklist: "Select checklist",
  Otp: "OTP",
  otp_rule: "Enter a OTP",
  new_otp_plce: "Enter OTP",
  plce_select_company: "Select company",
  workflow_approve_title: "Approve workflow?",
  approve: "Approve",
  Content_Checklist: "Content Checklist",
  content_selection: "Content Selection",
  workflow_accept_title: "Accept workflow?",
  type: "Type",
  pending: "Pending",
  progress: "Progress",
  completed: "Completed",

  signature_required: "Signature is required",
  checklist_item: "Checklist Item",
  parameterized: "Parameterized",
  assign: "Assign",
  assign_workflow: "Assign workflow",
  mycontract: "My Contracts",
  kyc: "KYC",
  created_by: "Created by",
  download: "Download",
  email_valid_rule: "Enter  valid email",
  comment: "Comment",
  total: "Total",
  created_content: "Created content",
  approve_content: "Approve content",
  created_workflow: "CreatedWorkflow",
  assigned_workflow: "AssignedWorkflow",
  approvedWorkflow: "ApprovedWorkflow",
  inprogress: "Inprogress",
  pendingtasks: "Pending task",
  total_template: "Total template",
  total_content: "Total Content",
  total_workflow: "Total Workflow",
  total_task: "Total task",
  task_detail: "Task details",
  workflow_detail: "Workflow Details",
  content_details: "content details",
  email_must_rule: "Please enter email",
  Template_Fields: "Template Fields",
  clear: "Clear",
  total_company: "Total Companies",
  accepted_content: "Accepted Contents",
  rejection_comment: "Rejection Comment",
  contractexpiry: "Contract expiry",
  rule_contractexpiry: "Please enter contract expiry",
  type_of_input: "Type of input",
  type_your_signature: "Type your Signature",
  default_fields: "Default Fields",
  enterdigit: "Enter digit",
  please_select: "Please select one option",
  default_field: "Default fields",
  key: "Key",
  sample_content: "Sample content",
  create_SampleContent: "Create sample content",
  content_title: "Title",
  update_SampleContent: "Update sample content",
  notification: "Notification",
  plce_select_sample: "Select sample",
  review_comment: "Review comments",
  expire_on: "Expires on",
  my_contracts: "My contracts",
  my_task: "My Task",
  staff: "Staff",
  Select_staff: "Select Staff",
  Activation_date: "Activation Date",
  expire_date: "Expire Date",
  create_new: "Create new",
  workflow_popupconfirm_title: "Are you sure you want to submit the workflow?",
  taskname_contractname: "Name",
  designation: "Designation",
  designation_placeholder: "Enter Designation",
  contract: "Contract",
  create_template: "Create Template",
  create_date: "Created Date",
  filter: "Filters",
  content_no: "Content No",
  template_no: "Template No.",
  workflow_no: "Workflow No.",
  popup: "Popup",
  total_templates: "Template(s)",
  total_contents: "Content(s)",
  total_workflows: "Workflow(s)",
  total_companys: "Company(s)",
  content_types: "Content Type",
  total_tasks: "Task(s)",
  assigned_company: "Assigned Company(ies)",
  fill_vendor_detail: "Fill Vendor Details",
  workflow_reject_title: "Reject workflow",
  Assign_vendors: "Assignee Vendors",
  vendor_details: "Vendor Detail",
  other_Services: "Other Services",
  preference: "Preference",
  companyName: "CompanyName",
  Task_popupconfirm_title: "Are you sure you want to approve?",
  ApprovedTask: "Approved",
  signInProgress: "Signinprogress",
  company_content: "Company's Content",
  open: "Open",
  expired: "Expired",
  enable: "Enable",
  disable: "Disable",
  inactive: "InActive",
  active_confirm_title: "Are you sure want to activate this company?",
  inactive_confirm_title: "Are you sure want to deactivate this company?",
  enable_confirm_title:
    "Are you sure want to activate license of  this company?",
  disable_confirm_title:
    "Are you sure want to deactivate license of this company?",
  task_datasubmit_title: "Is your effective date and execution date the same?",
  renew_task_datasubmit_title:
    "Is your effective date is same as original contract's expiry date?",
  linkage_addendum_datasubmit_title:
    "Is your effective date same as execution date?",
  task_datasubmit_execution_title:
    "your Effective date is same as Execution date",
  renew_task_datasubmit_execution_title:
    "your effective date will be original contract's expiry date",
  content_validation:
    "You have not used some fields from the Template. Are you sure you want to submit the Content?",
  task_datasubmit_executionafter_title: "your effective date will be",
  import: "Import",
  create_bulk_task: "Create Bulk Task",
  sample_excel_file: "Sample Excel File",
  file: "File",
  import_SampleContent: "Import Sample content",
  import_contentType: "Import Contract type",
  import_category: "Import Category",
  import_workflow_type: "Import Workflowtype",
  import_checklist: "Import Checklist",
  Ok: "Ok",
  enable_licence: "Activate License",
  disable_licence: "Deactivate License",
  activate: "Activate",
  deactivate: "Deactivate",
  start_date: "Start date",
  end_date: "End date",
  effective_date: "Effective date",
  execution_date: "Execution date",
  contract_expiry: "Contract Expiry",
  phone_number: "Phone Number",
  dob: "DoB",
  age: "Age",
  Workflow_key: "Workflow Key",
  effective_execution_date_same: "Effective execution date same",
  level_1: "Level 1",
  task_start_date: "Task start date",
  task_end_date: "Task end date",
  secretAccessKey: "Secret Access Key",
  keyId: "Key Id",
  storageType: "Storage Type",
  Select_Email: "Select Email",
  premium_features: "Premium Features",
  company_premium_features: "Company Premium Features",
  bulk_task: "Bulk Task",
  awsBucketRegion: "AWS Bucket Region",
  awsBucketName: "AWS Bucket Name",
  storagetype_confirm_title:
    "From Now your data will stored in provided bucket",
  tlp_storageType: "Select your storage type",
  tlp_key_id:
    "The AWS Key ID is a unique identifier for accessing your storage in AWS. It can be obtained from your AWS account dashboard.",
  tlp_secretAccessKey:
    "The AWS Secret Access Key is a confidential key used for authentication and access to your AWS storage. Make sure to keep it secure and avoid sharing it.",
  tlp_awsBucketName:
    "The AWS Bucket Name refers to the unique name of your storage bucket in AWS. It is used to identify and access the specific bucket where your data is stored.",
  tlp_awsBucketRegion:
    "The AWS Bucket Region represents the geographical region where your storage bucket is located. It determines the physical location where your data is stored.",
  user_details: "User Details",
  access_key_id: "AccessKeyId",
  upload_request: "Upload request",
  change_request: "Change request",
  update_request: "Update request",
  changes_history: "Changes History",
  template_history: "Template History",
  history: "History",
  upload_request_title: "What do you want to change?",
  content_: "Content",
  changes: "Changes",
  review_changes: "Review changes",
  historical_contract: "Legacy Contracts",
  create_historical_contract: "Create Legacy Contract",
  update_historical_contract: "Update Legacy Contract",
  contract_name: "Contract Name",
  contract_type: "Contract Type",
  parties_name: "Parties Name",
  parties_address: "Party Address",
  expiry_date: "Expiry date",
  form_name: "Form Name",
  form_type: "Extra Form Field Type",
  select_form_type: "Select extra field type",
  plce_contract_name: "Enter contract name",
  plce_parties_name: "Enter Parties name",
  plce_parties_desc: "Enter Parties description",
  plce_form_name: "Enter form name",
  select_contract_type: "Select contract type",
  details: "Details",
  preview: "Preview",
  noDataMsg: "No Data",
  extra_details: "Extra Details",
  comments_activity: "Comment/Activities",
  no_contracts: "No Contracts",
  Inprogress: "Inprogress",
  historical_Services: "Historical Services",
  Template_details: "Template Details",
  activities: "Activities",
  company_signatory: "Company Signatory",
  parties: "Parties",
  abort: "Abort",
  re_open: "Reopen",
  nickName: "Nickname",
  nickName_rule: "Please enter nickname",
  registeredAddress: "Registered Address",
  plce_nickName: "Enter nickname",
  plce_registeredAddress: "Enter registered address",
  registeredAddress_rule: "Please enter register address",
  content_types_contract_type: "Contract Type",
  verify_contract: "Verify Contract",
  relation_list: "Relation List",
  create_relation_list: "Create Relation Form",
  relation_form: "Relation Form",
  nickname_same_as_above_name: "Nickname same as above name ?",
  registerd_address_same_as_above: "Registerd address same as above?",
  terminate: "Terminate",
  addendum: "Addendum",
  create_addendum: "Create addendum",
  fill_template: "Fill template",
  addendumName: "Name",
  renew_contract: "Renew Contract",
  Default_View: "Grid View",
  vendor_view: "Vendor View",
  my_contract: "My contract",
  contract_details: "Contract Details",
  reviewer: "Reviewer",
  vendor_name: "Vendor Name",
  parent_contract_name: "Parent Contract Name",
  review: "Review",
  add_review: "Add Review",
  review_comp: "Complete Review",
  draft: "Draft",
  in_progress: "In Progress",
  userName: "User Name",
  GDD: "Google Drive Details",
  reviewer_name: "Reviewer Name",
  address1: "Address1",
  address2: "Address2",
  country: "Country",
  country_rule: "Select country",
  plce_country: "Please Select country",
  state: "State",
  select_state: "Select state",
  plce_state: "Please Select State",
  city: "City",
  select_city: "Select City",
  plce_city: "Please Select City",
  version: "Version",
  please_select_version: "Please select version",
  Select_version: "Select version",
  version_preview: "Version Preview",
  storageType_rule: "Please Select Storage Type",
  content_req_change: "Content Requested  Changes",
  comment_list: "Comment List",
  timeZone: "Timezone",
  verify: "Verify",
  timeZone_rule: "Please select timezone",
  plce_country_timezone: "Select timezone",
  connect_to: "Connect to",
  reconnect_to: "Connect",
  ok: "Ok",
  reasonArr: "Error",
  confirm_content: "Confirm content",
  address_2: "Address Line2",
  contract_verification: "Do you require contract verification ?",
  contract_count: "Do you require contract count ?",
  setcontract_count: "Enter Contract limit",
  content_count: "Do you require content count ?",
  setcontent_count: "Enter Content limit",
  contentLibrary_count: "Do you require content library count ?",
  setcontentLibrary_count: "Enter Content library limit",
  select_storages: "Select storages",
  select_contract_limit: "Is contract limited ?",
  sethistorical_count: "Enter Legacy Contract limit",
  select_historicalcontract_limit: "Is Legacy contract limited ?",
  hiscontract_count: "Do you require Legacy contract count ?",
  staff_count_limit: "Do you require limited reviewers ?",
  template_count_limit: "Do you require limited templates ?",
  workflow_count_limit: "Do you require limited workflows ?",
  vendor_count_limit: "Do you require limited vendors ?",
  signatory_count_limit: "Do you require limited signatories ?",

  settemplate_count_: "Enter Template limit",
  setvendor_count_: "Enter Vendor limit",
  setworkflow_count_: "Enter Workflow limit",
  setsignatory_count_: "Enter Signatory limit",
  select_staffcount_limit: "Is reviewer limited ?",
  setstaff_count_: "Enter Reviewer limit",
  resend_code: "Resend Code",
  otp_required: "OTP is required",
  otp_description:
    "Please enter the verification code which is send on your  email address",
  is_guest_user: "Login as a Guest User",
  License: "Licence",
  licence_name: "Plan name",
  licensing_features: "Licensing features",
  planpackages: "Plans",
  no_list: "No List",
  plans: "My plan",
  termination_date: "Termination date",
  execution_status: "Execution status",
  plce_parties_add: "Client address",
  cp_address: "Counter party address",
  cp_name: "Counter party name",
  cp_detail: "Counter party details",
  your_role: "Your role",
  cp_business_type: "Counter party business type",
  client_name: "Client name",
  client_address: "Client address",
  extra_delete_titte: "Are you sure delete this extra form?",
  guest_user: "Guest User",
  last7Days: "Last 7 Days",
  last30Days: "Last 30 Days",
  currentMonth: "Current Month",
  lastMonth: "Last Month",
  last3Months: "Last 3 Months",
  last6Months: "Last 6 Months",
  Oneyear: "Last 1 Year",
  obligation: "Obligation",
  create_obligation: "Create obligation",
  myobligation: "My obligation",
  step_4: "Step 4",
  assign_to: "Assign to",
  slaType: "SLA",
  update_obligation: "Update obligation",
  adobe: "Adobe",
  signature: "Signature",
  select_signatures: "Select signature",
  obligation_Services: "Obligation Services",
  onbgname_rule: "Please enter obligation name",
  slatype_type_rule: "Please select service level agreement",
  please_select_obligationForm: "Please select obligation form",
  create_obligation_form: "Create obligation form",
  attachment_rule: "Please add attachment",
  accept: "Accept",
  frequency_type_rule: "Select frequency",
  staff_assignee: "Staff Assignee",
  please_add_reject_comment: "Please add comment",
  please_add_reject_comment_empty: "Comment can't be an empty",
  Contractclause: "Contract clause",
  add_rejection_comment: "Add comment",
  obligation_delete_title_workflow:
    "Are you sure you want to delete this obligation?",
  frequency: "Frequency",
  obligation_delete_title: "Are you sure you want to delete this Obligation?",
  obligationform_delete_titte:
    "Are you sure you want to delete this Obligation form?",
  activity: "Activity",
  department: "Department",
  plz_select_dept: "Please select department",
  select_dept: "Select department",
  enter_limit: "Enter Limit",
  phone_limit: "Please enter a valid limit",
  financial_limit: "Financial Limit Sign",
  chat: "Chat",
  plan_delete_title: "Are you sure want to delete this plan?",
  content_lib: "Content Library",
  import_content: "Import Content",
  pick_content_from: "Select Content from Library",
  Docusign: "Docusign",
  Reviewer_title_req: "How many internal reviewers are required ?",
  approval_title_req: "How many signatories are required ?",
  renewalName: "Renewal Name",
  task_id: "TaskId",
  cname_emptyrule: "Company name cannot be an empty string",
  email_emptyrule: "Email cannot be an empty string",
  designation_emptyrule: "Designation cannot be an empty string",
  firstname_emptyrule: "First name cannot be an empty string",
  lastname_emptyrule: "Last name cannot be an empty string",
  registeredAddress_emptyrule: "Address cannot be an empty string",
  nickName_emptyrule: "Nick name cannot be an empty string",
  obligations: "Obligations",
  date: "Date",
  plce_select_content_type: "Select type",
  please_content_type_rule: "Please select content type",
  id: "Id",
  contract_no: "Contract No",
  sign_delete_title: "Are you sure want to delete signature?",
  googledrive_delete_confirm_title:
    "Are you sure you want to delete Google Storage? From now on, your contract will be stored in the default storage.",
  clause_lib: "Clause Library",
  create_clause: "Create Clause",
  update_clause: "Update Clause",
  clause: "Clause",
  last_modified: "Last Modified",
  plce_clauseDescription: "Describe the type of clause",
  plce_clauseName: "Name the type of clause, e.g. Ammendment,Meditation etc.",
  clause_delete_title: "Are you sure you want to delete this Clause?",
  fields: "Fields",
  clauseDescription_rule: "Please describe the clause",
  clauseName_rule: "Please enter clause name ",
  forgot_password_: "Forgot password",
  request: "Request(s)",
  signout: "Sign Out",
  Contact_sales: "Contact Sales",
  all: "All",
  unread: "Unread",
  contractType: "Contract Type",
  create_contractType: "Create Contract Type",
  express_contract: "Express Contract",
  datamanager: "Data Manager",
  display_name: "Display Name",
  datatype: "DataType",
  unassign_delete_title: "Are you sure you want to unassign this contract?",
  bulk_assign_modal_title: "Bulk Assign To Legal Associates",
  delete_duplicates: "Delete Duplicates",
  delete_duplicate: "Delete Duplicate",
  counterparty: "Counterparty",
  import_addendum: "Import Addendum",
  contract_admin: "Contract Admin",
  user_admin: "User Admin",
  contract_admin: "Contract Admin",
  welcome: "Welcome",
  setting: "Setting",
  help: "Help",
  companyPlansHeading: "Plan details :-",
  companyPlansBasic: "Basic",
  companyPlansExpiresOn: "Expires on:-",

  // Individual item labels (singular)
  companyPlansContent: "Content",
  companyPlansContents: "Contents",
  companyPlansContentInLibrary: "Content In Library",
  companyPlansContentsInLibrary: "Contents In Library",
  companyPlansWorkflow: "workflow",
  companyPlansWorkflows: "workflows",
  companyPlansContract: "contract",
  companyPlansContracts: "contracts",
  companyPlansHistoricalContract: "Legacy contract",
  companyPlansHistoricalContracts: "Legacy contracts",
  companyPlansReviewer: "reviewer",
  companyPlansReviewers: "reviewers",
  companyPlansVendor: "vendor",
  companyPlansVendors: "vendors",
  companyPlansSignatory: "signatory",
  companyPlansSignatories: "signatories",

  // Unlimited labels
  companyPlansUnlimitedContents: "Unlimited Contents",
  companyPlansUnlimitedContentsLibrary: "Unlimited Contents In Library",
  companyPlansUnlimitedWorkflow: "Unlimited Workflow",
  companyPlansUnlimitedContracts: "Unlimited Contracts",
  companyPlansUnlimitedHistoricalContracts: "Unlimited Legacy Contracts",
  companyPlansUnlimitedReviewers: "Unlimited reviewers",
  companyPlansUnlimitedVendors: "Unlimited vendors",
  companyPlansUnlimitedSignatories: "Unlimited signatories",

  // Upto labels with dynamic values
  companyPlansUptoContent: "Upto {count} {type}",
  companyPlansUptoContentLibrary: "Upto {count} {type}",
  companyPlansUptoWorkflow: "Upto {count} {type}",
  companyPlansUptoContracts: "Upto {count} {type}",
  companyPlansUptoHistoricalContracts: "Upto {count} {type}",
  companyPlansUptoReviewers: "Upto {count} {type}",
  companyPlansUptoVendors: "Upto {count} {type}",
  companyPlansUptoSignatories: "Upto {count} {type}",

  // Feature access labels
  companyPlansAccessBulkTask: "Access To Bulk Task",
  companyPlansVerifyContracts: "Verify Contracts",
  companyPlansStorageType: "Storage Type ({storageTypes})",
  settingsTitle: "Settings",
  settingsLanguageCardTitle: "Language Settings",

  // Language selection
  settingsSelectLanguage: "Select Language",
  settingsSelectLanguageDescription:
    "Choose your preferred language for the application interface",
  settingsSelectLanguagePlaceholder: "Select a language",

  // Language names
  settingsLanguageEnglish: "English",
  settingsLanguageGerman: "Deutsch",
  settingsLanguageFrench: "Français",

  // Current selection
  settingsCurrentSelection: "Current Selection",

  // Action buttons
  settingsSaveChanges: "Save Changes",
  settingsResetToDefault: "Reset to Default",

  // Messages
  settingsLanguageSaveSuccess: "Language changed successfully!",
  explore: "Explore",
  esignservice: "eSignature service",
  connected: "Connected",
  not_connected: "Not Connected",
  setcronjobduration: "Notify Before Expiry",
  days: " Days",
  hours: " Hours",
  minutes: " Minutes",
  weeks: "Weeks",
  duration: "Duration",
  and: "and",
  remaining: "Remaining",
  expired_on: "Expired on",
  digit_is_required: "Digit is required",
  set_duration: "Notify Before Expiry",
  please_enter_a_valid_limit: "Please enter a valid limit",
  enter_digit: "Enter digit",
  storage: "Storage",
  obligation_management: "Obligation Management",
  filter: "Filter",
  grid_view: "Grid View",
  list_view: "List View",
  select_view: "Select View",
  select_template: "Select Template",
  select_workflow: "Select Workflow",
  select_obligationform: "Select Obligation Form",
  select_content: "Select Content",
  select_clause: "Select Clause",
  select_vendor: "Select Vendor",
  select_signatory: "Select Signatory",
  select_reviewer: "Select Reviewer",
  select_department: "Select Department",
  select_plan: "Select Plan",
  vendor_view: "Vendor View",
  basic_details: "Basic Details",
  contract_id: "Contract ID",
  counterparty_name: "Counterparty Name",
  counterparty_email: "Counterparty Email",
  party_details: "Party Details",
  add: "Add",
  addendums: "Addendums",
  no_addendum_are_available: "No addendum are available",
  view_more: "View More",
  overall_status: "Overall Status",
  company: "Company",
  no_obligations_are_available: "No obligations are available",
  contract_family: "Contract Family",
  latest: "Latest",
  archive: "Archive",
  contract_management: "Contract Management",
  your_10_most_recent_notifications: "Your 10 most recent notifications",
  view_all: "View All",
  notifications: "Notifications",
  artifact_status: "Artifact Status",
  contract_types_count: "Contract Types Count",
  contract_status: "Contract Status",
  monthly_contract: "Monthly Contract",
  contract_monthly_count: "Contract Monthly Count",
  historical: "Historical",
  historical_contract_status: "Legacy Contract Status",
  graph: "Graph",
  contract_graph: "Contract Graph",
  staff_status: "Staff Status",
  tasks: "Tasks",
  workflows: "Workflows",
  contents: "Contents",
  grid_view: "Grid View",
  inactive: "Inactive",
  terminated: "Terminated",
  start_date: "Start Date",
  contract_type: "Contract Type",
  contract_from: "Contract From",
  historical_contracts: "Legacy Contracts",
  normal_contracts: "Normal Contracts",
  analyse_risk_with_ai: "Analyse Risk with AI",
  create_linkage: "Create Linkage",
  add_obligations: "Add Obligations",
  restructure: "Restructure",
  linkage: "Linkage",
  task_no: "Task No.",
  table_search_placeholder: "Search ...",
  table_filter_ok: "Ok",
  table_filter_reset: "Reset",
  table_no_data: "No Data",
  table_pagination_items_per_page: "/ Page",
  table_pagination_show_total: "{range0}-{range1} of {total} items",
  workflow_suggestion: "Workflow Suggestion",
  additional_notes: "Additional Notes",
  enter_any_extra_information_here: "Enter any extra information here",
  value: "Value",
  contract_value: "Contract Value",
  which_type_of_department_is_used_for: "Which type of department is used for?",
  additional_information: "Additional Information",
  question: "Questions",
  task_information: "Task Information",
  no_workflow_found: "No Workflow Found",
  reviewandconfirm: "Review & Confirm",
  review_your_task: "Review Your Task",
  priority: "Priority",
  task_startdate: "Task StartDate",
  task_enddate: "Task EndDate",
  task_description: "Task Description",
  select_files: "Select Files",
  clear_files: "Clear Files",
  historical_contract_limit_exceeded: "Legacy contract Limit exceeded",
  upload_record: "Upload Record",
  download_sample_contracts: "Download sample contracts",
  dont_have_handy_contracts_text:
    "Don't have your contracts handy? Try importing our sample contracts.",
  ai_smart_import_coming_soon: "AI-Smart Import (Coming soon)",
  import_text_without_ai:
    "Upload files without using AI to tag data. AI will be used to OCR documents to allow for advanced search, and you maymanually tag data after upload.",
  add_more: "Add more",
  selected: "Selected",
  drop_file_here: "Drop files here",
  browse_files: "Browse Files",
  files: "files",
  or: "Or",
  import_from: "Import from",
  my_device: "My Device",
  drive: "Drive",
  dropbox: "Dropbox",
  onedrive: "Onedrive",
  connect_to_google_drive: "Connect to Google Drive",
  open_file_picker: "Open File picker",
  ready: "Ready",
  empty: "Empty",
  oversized: "Oversized",
  note: "Note",
  do_not_upload_scanned_pdf: "Do not upload scanned pdf",
  supports_files_under: "Supports File Under",
  validfile: "Valid File",
  invalidfile: "InValid File",
  import_from_google_drive: "Import from google drive",
  smart_import: "Smart Import",
  save_time_by_using: "Save time by using",
  smart_import_extra_text:
    "models to scan text and automatically detect and tag key pieces of data during upload. Records will be instantly searchable and filterable",
  export: "Export",
  create_with: "Create With",
  admin: "Admin",
  select_content_from_library: "Select content from library",
  role_fields: "Role Fields",
  custom_fields: "Custom Fields",
  company_fields: "Company Fields",
  counterparty_fields: "Counterparty Fields",
  contract_fields: "Contract Fields",
  default_fields: "Default Fields",
  help_box: "Help Box",
  for_contract_fields: "for Contract fields",
  for_role_fields: "for Role fields",
  use: "Use",
  sort_by_a_z: "Sort by A-Z",
  sort_by_z_a: "Sort by Z-A",
  sort_by_created_at: "Sort by CreatedAt",
  sort_by_updated_at: "Sort by UpdatedAt",
  default: "Default",
  add_field: "Add Field",
  add: "Add",
  import_addendum: "Import Addendum",
  cancel: "Cancel",
  import: "Import",
  upload_pdf_only: "Please upload only PDF files!",
  file_size_limit: "File size must be less than 10MB!",
  file_selected_successfully: "{filename} selected successfully!",
  file_removed_successfully: "File removed successfully!",
  upload_pdf_first: "Please upload a PDF file first",
  click_or_drag_file_to_upload: "Click or drag file to upload",
  support_pdf_max_size: "Support PDF files only • Max size: 10MB",
  file_ready_to_submit: "File selected and ready to submit",
  preview: "Preview",
  remove: "Remove",
  click_or_drag_to_replace_file: "Click or drag to replace file",
  weekly: "Weekly",
  monthly: "Monthly",
  quartely: "Quarterly",
  yearly: "Yearly",
  daily: "Daily",
  obligation_no: "Obligation No",
  view_obligation_of: "View obligations of",
  contract_clause: "Contract clause",
  currently_you_have_no_obligation_for_this_task:
    "Currently! you have no obligation for this task",
  due_date: "Due Date",
  expiry: "Expiry",
  waiting: "Waiting",
  accepted: "Accepted",
  rejected: "Rejected",
  attached_documents: "Attached Documents",
  attachments: "Attachments",
  dragger_upload_text: "Click or drag file to this area to upload",
  dragger_upload_hint:
    " Supported file formats: PDF, PNG, JPG. Please upload a file in one of these formats.",
  uploading: "Uploading",
  descriprion_rule: "Please enter a valid description",
  add_documents: "Add Documents",
  enter_your: "Enter Your",
  contract_duration_rule: "Please select Contract duration",
  contract_expiry_rule: "Please add Contract expiry",
  click_to_upload: "Click to Upload",
  please_enter: "Please Enter",
  phone_rule_: "Phone no must be 8 - 14 digit long",
  view_form: "View Form",
  fill_form: "Fill Form",
  file_uploaded_successfully: "file uploaded successfully",
  file_uploaded_failed: "file upload failed",
  file_supporting_message: "Only PDF, JPG, JPEG, and PNG files are allowed!",
  years: "Years",
  months: "Months",
  choose_content: "Choose Content",
  add_obligation: "Add Obligation",
  add_approver_rule: "Please! Add Approval",
  strategy_rule: "Select! strategy atleast two",
  integration: "Integration",
  eSign: "eSign",
  back_to_integration: "Back to integration",
  unlink_account: "Unlink Account",
  link_account: "Link Account",
  integration_status: "Integration Status",
  connected_at: "Connected At",
  approval_in_progress: "Approval InProgress",
  approved: "Approved",
  signature_inprogress: "Signature InProgress",
  update_accepted: "Update Accepted",
  update_rejected: "Update Rejected",
  update_completed: "Update Completed",
  aborted: "Aborted",
  internal_review: "Internal Review",
  review_completed: "Review Completed",
  reviewed: "Reviewed",
  upload_xlsx_file: "Upload XLSX File",
  supportive_format_note: "Supportive file format is XLSX",
  upload_format_tooltip: "Upload file should be in XLSX format",
  update_obligation_form: "Update Obligation Form",
  number: "Number(123...)",
  text: "Text (Abc...)",
  textarea: "Textarea",
  decimal: "Decimal",
  radio: "Radio",
  checkbox: "Checkbox",
  dropdown: "Dropdown",
  datepicker: "Datepicker",
  permission: "Permission",
  financial_limit_rule: "Please enter the financial limit",
  correct_email_warning: "Please enter the correct email address.",
  input_text_validation_message:
    "Only letters, numbers, and spaces are allowed.",
  enter_valid_name: "Enter valid name",
  enter_valid_description: "Enter valid description",
  workflow_created_successfully: "Workflow Created Successfully!",
  workflow_success_subtitle: "Would you like to create task now or later?",
  later: "Later",
  go_to_task: "Go to task",
  assign_now: "Assign Now",
  reviewer_count: "Reviewer Count",
  signatory_count: "Signatory Count",
  please_select_yes_or_no: "Please select Yes or No!",
  obligations_label_for_attach:
    "Do you want to attach obligations for this workflow ?",
  pagination_showTotal: "{start}-{end} of {total} items",
  on: "On",
  off: "Off",
  text_editor: "Text Editor",
  unknown: "Unknown",
  enter_defination: "Enter definition",
  definition: "Definition",
  definition_rule: "Please enter definition",
  enter_property: "Enter Property",
  property_key: "Property Key",
  property_key_rule: "Please enter property key",
  create_new_fields: "Create New Field",
  update_field: "Update Field",
  field_name: "Field Name",
  field_rule: "Please enter field name",
  field_placeholder: "Enter Field Name",
  select_datatype_rule: "Please select Datatype",
  terminate_confirmation: "Are you sure you want to terminate this contract?",
  ai_analysis_failed: "AI Analysis failed",
  day_s: "Day(s)",
  Parent: "Parent",
  Child: "Child",
  ADDENDUM: "ADDENDUM",
  no_data_found: "No Data Found",
  assigned: "Assigned",
  signed: "Signed",
  please_select_at_least_one: "Please select at least one",
  lifecycle_rule_text: "Please fill in fields of Lifecycle Details",
  extra_rule_text: "Please fill in fields of Extra Details",
  label_changed_successfully: "Label changed successfully",
  model: "Model",
  edit_prompt: "Edit Prompt",
  fill_with_ai: "Fill With AI",
  lifecycle_detail: "Lifecycle Details",
  parent_contract: "Parent Contract",
  list_View: "List View",
  contract_type_rule: "Contract type is required",
  phone_valid_rule: "Please enter valid phone number",
  enter: "Enter",
  task_no: "Task No",
  contract: "Contract",
  status: "Status",
  assigned: "Assigned",
  completed: "Completed",
  unassigned: "Unassigned",
  duplicate: "Duplicate",
  duplicate_of: "Duplicate of",
  assigned_to: "Assigned To",
  assigned_date: "Assigned Date",
  submission_date: "Submission Date",
  actions: "Actions",
  view: "View",
  edit: "Edit",
  assign: "Assign",
  reassign: "Reassign",
  imported_on: "Imported on",
  remove_duplicates: "Remove Duplicates",
  no_missing_contract: "No Missing Contract Found",
  no_missing_contract_found: "No Missing contract Found",
  missing_contract: "Missing Contract",
  find_missing_contract: "Find Missing Contract",
  general_ai_prompt: "General AI prompt",
  upload_info: "Upload Info",
  bulk_reassign: "Bulk Reassign",
  bulk_assign: "Bulk Assign",
  assign_to_legal_associate: "Assign to Legal associate",
  total: "Total",
  all: "All",
  search: "Search...",
  filter: "Filter",
  no_contracts: "No Contracts",
  ai_processing: "AI processing",
  finding_missing_contracts: "Finding Missing contracts...",
  ai_context_prompt: "AI Context Prompt",
  please_input_ai_prompt: "Please input AI Prompt!",
  enter_detailed_prompt_for_ai_analysis:
    "Enter detailed prompt for AI analysis",
  imported: "Imported",
  delete_duplicate_records: "Delete duplicate records",
  delete_duplicates_confirmation:
    "Are you sure you want to delete {count} duplicate record(s)?",
  found_duplicates_message:
    "We found duplicates for {count} record{count, plural, one {} other {s}}. We can help you delete the duplicates while keeping the originals.",
  ai_preview: "AI Preview",
  pdf_loaded_success: "Contract PDF loaded successfully",
  pdf_loading_error: "Error loading PDF. Please try again.",
  loading_pdf: "Loading PDF...",
  failed_to_load_pdf: "Failed to load PDF",
  ai_suggestions: "AI Suggestions",
  show_highlights: "Show Highlights",
  hide_all: "Hide All",
  side_all: "Side All",
  page: "Page",
  copyright: "Copyright © {startYear}-{endYear}. All Rights Reserved.",
  select_content_rule: "Please Select Content",
  review_and_send: "Review and Send",

  new_version_available_review:
    "There is a new version available. Please review it",

  collab: "Collab",
  more: "More",
  complete_review: "Complete Review",
  edit_info: "Edit Info",
  back: "Back",
  dept: "Department",
  service_level_agrrement: "Service level agreement",
  select_obligation_template: "Select Obligation Template",
  please_select_obligation_template: "Please Select Obligation Template",
  non_collab: "Non Collab",

  collab_active: "Collaborative mode is Active",
  collab_inactive: "Collaborative mode is Inactive",
  collaborative: "Collaborative",
  missing_required_fields: "Missing {count} required fields",

  approve_and_sign: "Approve and Sign",
  need_assistance: "Need assistance? Visit our",
  help_center: "Help Center",
  or_email: "or email",
  no_activities: "No Activities",
  counterparty_information: "Counterparty Information",
  counterparty_select_rule: "Please select a counterparty",
  invite_via_email: "Invite via email",
  vendor_limit_exceeded:
    "Vendor Limit exceeded as per your plan. Please change the plan as required",
  change_expiry_label: "Do you want to change expiry?",
  contract_information: "Contract Information",
  company_information: "Company Information",
  reviewer_information: "Reviewer Information",
  reviewer_select_rule: "Please select a Reviewer",
  add_new: "Add New",
  email_document: "Email Document",
  cancel: "Cancel",
  send: "Send",
  to: "To",
  cc: "Cc",
  subject: "Subject",
  draft_contract: "Draft Contract",
  please_review: "Please Review",
  dear: "Dear",
  reviewer: "Reviewer",
  signatory: "Signatory",
  you_have_been_added_as: "You have been added as a",
  in_the_following_contract: "in the following contract.",
  contract_name: "Contract Name",
  please_find_the_contract_attached:
    "Please find the contract attached in this email and review the contract clauses. If any addition or changes are required, please write us back at the company mail",
  best_regards: "Best Regards,",
  team: "Team",
  replies_appear_in_activity:
    "Replies to this email will automatically appear in the activity feed",
  processing: "Processing",
  parameterizing_field_text: "We are parameterizing fields in content",
  if: "If",
  wait_moment: "Please wait for a moment",
  delete_comment_title: "Are you sure you want to delete this comment",
  contract_success_message: "Congrats! Your contract was created successfully",
  go_to_my_contracts: "Go to my contracts",
  obligation_expiry: "Obligation Expiry",
  add_comment: "Add Comment",
  assign_obligation: "Assign Obligation",
  please_select_one: "Please select one",
  enter_contract_clause: "Enter contract clause",
  enter_clause: "Enter clause",
  select_obligation: "Select obligation",
  already_used: "Already used",
  obligation_template: "Obligation Template",
  sla_weekly_review: "Weekly Review",
  sla_priority_standard: "Standard Priority",
  sla_weekly_description: "This obligation requires a weekly review.",

  sla_monthly_check: "Monthly Check",
  sla_priority_routine: "Routine Priority",
  sla_monthly_description: "This obligation requires a monthly check.",

  sla_quarterly_report: "Quarterly Report",
  sla_priority_important: "Important Priority",
  sla_quarterly_description: "This obligation requires a quarterly report.",

  sla_annual_review: "Annual Review",
  sla_priority_strategic: "Strategic Priority",
  sla_annual_description: "This obligation requires an annual review.",

  sla_daily_monitoring: "Daily Monitoring",
  sla_priority_critical: "Critical Priority",
  sla_daily_description: "This obligation requires daily monitoring.",

  company_label: "Company",
  counterparty_label: "Counterparty",

  this_obligation: "this obligation",
  remove_confirmation_title: "Are you sure you want to remove {name}?",
  remove_obligation_warning: "Removing this obligation cannot be undone.",
  remove: "Remove",
  cancel: "Cancel",
  removed_successfully: "removed successfully",
  edit: "Edit",

  unnamed_obligation: "Unnamed Obligation",
  new_label: "New",
  no_description_available: "No description available",

  obligations_ready_to_add: "obligations ready to add",
  please_add_obligation_before_submit:
    "Please add at least one obligation before submitting.",
  add_obligation: "Add Obligation",
  contract_obligations_management: "Contract Obligations Management",
  adding_obligations_to_contract: "Adding obligations to contract {name}",
  document: "Document",
  contract_content: "Contract Content",
  obligations_library: "Obligations Library",
  add_new: "Add New",
  no_obligations_added_yet: "No obligations have been added yet.",
  click_add_new_to_create: "Click 'Add New' to create obligations.",
  lifecycle_info: "Lifecycle info",
  tag: "Tag",
  describe_why_field_is_use_for: "describe why field is use for?",
  option_duplicate_rule: "Options can not be duplicate",
  filter_contracts: "Filter Contracts",
  legal_associate: "Legal Associates",
  select_legal_associate: "Select legal associate",
  clear_filter: "Clear Filter",
  apply_filter: "Apply Filter",
  ongoing_review: "Ongoing Review",
  workflow_required_rule: "Please enter a workflow name",
  assign_contract: "Assign Contract",
  reassign_contract: "Reassign Contract",
  assign_contracts_text: "Assign {count} contract(s) to legal associate",
  reassign_contracts_text: "Reassign {count} contract(s) to legal associate",
  select_associate_rule: "Please select an associate",
  choose_associate: "Choose an associate",
  none: "None",
  confirm_unassign: "Are you sure you want to Unassign this contract?",
  confirm_assign_contracts:
    "Are you sure you want to assign {count} contract(s) to this associate?",
  bulk_assign_modal_title: "Bulk Assign To Legal Associates",
  select_assignment_method: "Select Assignment Method",
  document_range: "Document Range",
  percentage_range: "Percentage Range",
  range: "Range",
  from_document: "From Document",
  to_document: "To Document",
  assign_to: "Assign to",
  reassign_to: "Reassign to",
  required: "Required",
  to_doc_greater: "To Document must be greater than From Document",
  ranges_overlap: "Ranges cannot overlap",
  create_range: "Create Range",
  cancel: "Cancel",
  assign: "Assign",
  reassign: "Reassign",
  warning_all_assigned: "All documents are already assigned",
  error_add_range: "Error adding new range",
  please_fill_required: "Please fill all required fields",
  check_all: "Check All",
  verify_text_rule: "Verify the details by clicking on checkbox",
  input_must_50: "Input must be 50 characters or less.",
  new_chat: "New Chat",
  ai_powered: "AI-Powered",
  ask: "Ask",
  type_a_message: "Type a message...",
  please_wait: "Please wait...",
  versions: "Versions",
  compare: "Compare",
  no_version_yet: "No version yet",
  with: "With",
  export_record: "Export Record",
  upload: "Upload",
  click_or_drag_file: "Click or drag file to this area to upload",
  upload_hint:
    "Support for a single or bulk upload. Strictly prohibit uploading company data or other banned files",
  file_selected: "file selected",
  file_upload_failed: "file upload failed.",
  only_xlsx_allowed: "You can only upload .xlsx files!",
  error_reading_excel:
    "Failed to read the Excel file. Please check the format.",
  analysis_report: "Analysis Report",
  ai_analysing_text: "AI is analysing the Document",
  complete_review_document: "Complete Review Document",

  only_doc_allowed: "Only .doc and .docx files are allowed!",
  delete_comment: "Delete Comment",
  content_template: "Content Templates",
  task_approved: "Task Approved",
  out_for_signature: "Out for signature",
  go_back: "Go Back",
  legacy_imports: "Legacy Imports",
  imported_on: "Imported on",
  view_legacy_imports: "View Legacy Imports",
  import_name: "Import Name",
  imported_by: "Imported By",
  records_imported: "Records Imported",
  upload_meta_data: "Upload MetaData",
  enter_number: "Enter Number",
  enter_number_in_range: "Enter Number In Range",
  contracts_progress: "Contract Progress",
  contractId: "ContractId",
  ai_credits: "AI Credits (Trial)",
  contracts: "Contracts",
  legacy_contracts: "Legacy Contracts",
  edit_linkage: "Edit Linkage",
  legacy: "Legacy",
  native: "Native",
  relationship:"Relationship",
  
};
